import { initPopover } from "./popover-CGNoywPj.js";

//#region src/vanilla/dropdown/index.ts
const initDropdown = ({ id, disableAutoPlacement = false, placement = "bottom", positionMiddleware = [] }) => {
	initPopover({
		id,
		disableAutoPlacement,
		placement,
		positionMiddleware
	});
};

//#endregion
export { initDropdown };
//# sourceMappingURL=dropdown-C1hpsZcN.js.map